import { t } from '@lingui/macro';
import React, { FunctionComponent } from 'react';

import { CustomFieldValue } from '@api/v4/assets/customFieldTypes';
import { CustomFieldKeyValuesEntry } from '@components/asset/modal/tabs/edit/EditTabTypes';
import { StandardTextField } from '@components/library/text-field';
import { isEmptyOrBlankValue } from '@components/show_page/sections/asset/required-custom-fields-dialog-helper';

import { getCustomFieldAccessibleName } from './customFieldAccessibleLabel';

interface SingleValueFreeEntryProps {
  customFieldKeyId: string;
  existingCustomFieldMap: CustomFieldKeyValuesEntry;
  /** ID of the visible key label element for aria-labelledby. */
  fieldLabelId?: string;
  /** Visible key name; used as the input's accessible name when no label element is linked. */
  fieldName?: string;
  handleUpdate: (customFieldValue: CustomFieldValue, customFieldRequired?: boolean) => void;
  required: boolean;
}

export const SingleValueFreeEntry: FunctionComponent<SingleValueFreeEntryProps> = ({
  customFieldKeyId,
  existingCustomFieldMap,
  fieldLabelId,
  fieldName,
  handleUpdate,
  required
}) => {
  const value = existingCustomFieldMap?.customFieldValues.length > 0
    ? existingCustomFieldMap?.customFieldValues[0].value
    : '';

  const touched = existingCustomFieldMap?.customFieldTouched;
  const showError = required && touched && isEmptyOrBlankValue(value);
  const accessibleLabel = getCustomFieldAccessibleName(fieldName);

  return (
    <StandardTextField
      aria-labelledby={fieldLabelId}
      className={`custom-field-primary-input${!showError ? ' top-container-hidden' : ''}`}
      error={showError ? t`Value required` : undefined}
      id={`custom-field-value-input--${customFieldKeyId}`}
      label={accessibleLabel}
      name={`custom-field-value-input--${customFieldKeyId}`}
      onChange={(e): void => {
        const customFieldValueId = existingCustomFieldMap?.customFieldValues.length > 0
          && existingCustomFieldMap?.customFieldValues[0].key;
        handleUpdate({ key: customFieldValueId || '', value: (e as InputChangeEvent).target.value }, required);
      }}
      placeholder={t`Input value`}
      required
      showLabel={false}
      value={value}
    />
  );
};
